<template>
  <div class="page-set-container">
    <el-collapse v-model="activeNames" @change="handleChange">
      <el-collapse-item title="版心宽度" name="1" v-if="request_prefix === 'stage' && !isSubHeadPage">
        <div class="setting-item clearFloat">
          <div>

            <el-select :value="customWidth === 'custom'?'自定义': pageWidth"  @change="setPageWidthType" class="height32 percent100">
              <el-option
                v-for="(item, index) in pageWidthList"
                :key="index"
                :value="item.value"
                :label="item.title"
              >{{ item.title }}
              </el-option>
            </el-select>
            <single-input
              v-if="customWidth === 'custom'"
              class="size-inp mt12"
              :value.sync="pageWidth"
              inputSuffixs="px"
              :min="100"
              :max="1920"
            />
          </div>
        </div>
      </el-collapse-item>
      <!-- 非首页主题色跟随首页，所以只有首页展示主题色设置-->
      <el-collapse-item title="主题色" name="2" v-if="isHomePage">
        <template v-if="themeColorList.length">
          <div v-for="(themeColor, index) in themeColorList" :key="index" class="color-picker-container">
            <el-color-picker
              class=""
              v-model="themeColorList[index].color"
              @change="activeChangeColorList($event, index)"
            ></el-color-picker>
            <span class="floatLeft color-text mr8">{{ themeColorList[index].color }}</span>
          </div>
        </template>
        <div v-else class="color-picker-container">
          <el-color-picker
            class="floatLeft"
            v-model="themeColor"
            @active-change="activeChangeColor"
            @change="onChangeColor"
          ></el-color-picker>
          <span class="floatLeft color-text">{{ themeColor }}</span>
        </div>
      </el-collapse-item>
      <el-collapse-item title="背景" name="3">
        <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" />
      </el-collapse-item>
      <el-collapse-item title="下拉刷新" name="4" v-if="request_prefix === 'appStage'">
        <el-switch v-model="enablePullRefresh" active-color="#3D82F2"></el-switch>开启下拉刷新
        <template v-if="enablePullRefresh">
          <div class="mt16 font14 mr10">下拉文案</div>
          <div class="mt8">
            <el-input class="width-half-bigWidth el-input el-input--suffix" placeholder="请输入" v-model="pullText">
            </el-input>
          </div>
          <div class="mt16 font14 mr10">释放文案</div>
          <div class="mt8">
            <el-input class="width-half-bigWidth el-input el-input--suffix" placeholder="请输入" v-model="releaseText">
            </el-input>
          </div>
        </template>
      </el-collapse-item>
      <el-collapse-item title="背景音乐" name="5" class="music-set" v-if="!isSubHeadPage">
        <el-radio-group v-model="musicType" class="mb16">
          <el-radio label="本地上传">本地上传</el-radio>
          <el-radio label="音频地址">音频地址</el-radio>
        </el-radio-group>
        <div v-if="musicType == '本地上传'">
          <el-upload
            name="uploadFile"
            action="/engine2/usts"
            accept=".mp3,.mp4,.wma"
            :on-preview="handleMusicPreview"
            :on-success="handleMusicSuccess"
            :on-error="handleMusicfail"
            :show-file-list="false"
            v-show="!musicSrc"
          >
            <el-button v-if="!musicSrc" class="upload-btn mb8"><span class="icon-portal-plus"></span> 上传音频</el-button>
          </el-upload>
          <div class="content-item card mb8" v-show="musicSrc">
            <p class="music-name">{{ musicName }}</p>
            <div class="verticallyTop height24">
              <el-upload
                name="uploadFile"
                action="/engine2/usts"
                accept=".mp3,.wma"
                :on-preview="handleMusicPreview"
                :on-success="handleMusicSuccess"
                :on-error="handleMusicfail"
                :show-file-list="false"
              >
                <span class="handle-icon-box mr4" @mousedown.stop
                  ><i class="icon icon-portal-edit-1"></i><span class="icon-tips">重新上传</span></span
                >
              </el-upload>
              <span class="handle-icon-box" @mousedown.stop @click="handleMusicDel"
                ><i class="icon icon-portal-delete1"></i><span class="icon-tips">删除</span></span
              >
            </div>
          </div>
          <p class="tips mb10">支持MP3、WMA格式，大小不超过600M</p>
        </div>
        <div v-else class="music-input mb10">
          <el-input v-model="musicSrc" placeholder="音频链接地址"></el-input>
          <i class="icon-portal-close-one" v-show="musicSrc" @click="handleMusicDel"></i>
        </div>
        <div class="content-item verticallyCenter mb12" v-show="musicSrc">
          <span class="mr16 fs14">位置</span>
          <el-radio-group v-model="misicPosition">
            <el-radio label="left">左上</el-radio>
            <el-radio label="right">右上</el-radio>
          </el-radio-group>
        </div>
        <el-checkbox v-model="isLoopPlay" label="1" @click="this.isLoopPlay = !this.isLoopPlay"
          >开启循环播放
        </el-checkbox>
      </el-collapse-item>
      <el-collapse-item title="整屏切换" name="6" v-if="request_prefix === 'stage' && !isSubHeadPage">
        <el-checkbox v-model="enableFullScroll" title="切换效果" name="8">
          开启整屏切换<i class="tips-btn icon-portal-info2" @click.stop.prevent="explainDialogClick('changeFullScroll')"></i>
        </el-checkbox>
        <template v-if="showScrollModelSetting">
          <div>切换模式:</div>
          <el-radio-group v-model="scrollModel">
            <el-radio label="smooth">平滑切换</el-radio>
            <el-radio label="cover">覆盖切换</el-radio>
          </el-radio-group>
          <div>溢出设置:</div>
          <el-select v-model="overflowControl">
            <el-option value="hidden" label="隐藏"></el-option>
            <el-option value="scroll" label="滚动"></el-option>
            <el-option value="autoScale" label="自适应缩放"></el-option>
          </el-select>
        </template>
      </el-collapse-item>
      <el-collapse-item title="微信分享" name="7" v-if="isAdmin  && !isSubHeadPage">
        <el-checkbox v-model="isCustomWxShare" label="1" @click="this.isCustomWxShare = !this.isCustomWxShare"
          >开启微信分享自定义</el-checkbox
        >
        <div v-if="isCustomWxShare">
          <div class="mt8">
            <span>标题</span>
            <el-input v-model="shareTitle" placeholder="毕业阅读报告"></el-input>
          </div>
          <div class="mt8">
            <span>logo</span>
            <el-input v-model="shareLogo" placeholder="请输入http://或https://开头的地址"></el-input>
          </div>
          <div class="mt8">
            <span>高级设置</span>
            <el-radio-group v-model="shareType">
              <el-radio label="1">分享我的报告</el-radio>
              <el-radio label="2">分享报告地址</el-radio>
              <el-radio label="3">自定义分享内容</el-radio>
              <!--只有自定义内容的时候需要手动输入地址-->
              <el-input
                v-if="shareType == 3"
                v-model="shareUrl"
                placeholder="请输入在mh.chaoxing.com域名下的地址"
              ></el-input>
            </el-radio-group>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="用户须知" name="12" v-if="isHomePage">
        <el-checkbox v-model="enableNotice"
          >开启用户须知</el-checkbox
          ><i class="tips-btn icon-portal-info2 notice-tips" @click.stop="explainDialogClick('notice')"></i>
        <div class="block-setting mt8" v-if="enableNotice">
          <cx-slider 
            :showToolTip="false"
            :value.sync="showNoticeLayout" 
            :options="noticeOptions" label="预览"></cx-slider>
          <!-- <div class="mt8">
             <span class="fs13 mr16">触发</span> 
             <el-select v-model="noticeTriggerType" placeholder="请选择触发方式" style="width: 160px">
                  <el-option v-for="item in noticeTriggerOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
              </el-select>
          </div> -->
        </div>
      </el-collapse-item>
      <el-collapse-item title="全局样式" name="8" v-if="!isSubHeadPage">
        <codemirror v-model="globalStyle" :options="cmOptions" @blur="updateGlobalStyle()" ref="editor"></codemirror>
      </el-collapse-item>
      <el-collapse-item title="更多" name="9"  v-if="!isSubHeadPage">
        <!-- 放到左侧栏下 -->
        <!-- <div class="setting-item clearFloat mb12">
          <div>
            <el-checkbox v-model="isShowHeader" label="1" @click="this.isShowHeader = !this.isShowHeader"
              >显示头部</el-checkbox
            >
            <el-checkbox v-model="isShowFooter" label="1" @click="this.isShowFooter = !this.isShowFooter"
              >显示底部</el-checkbox
            >
            <el-checkbox v-model="isShowAnchor" label="1" @click="this.isShowAnchor = !this.isShowAnchor"
              >显示锚点</el-checkbox
            >
          </div>
        </div> -->
        <div class="content-item mb12">
          <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
        </div>
        <el-checkbox v-model="isBackgroundFixed" @click="this.isBackgroundFixed = !this.isBackgroundFixed">
          固定页面背景
          <i class="tips-btn icon-portal-info2" @click="explainDialogClick('openBgFixed')"></i>
        </el-checkbox>
        <div v-if="$store.state.states.showPluginSetting" class="content-item fs14 verticallyCenter mt12">
          <span class="mr20 flex1">
            基准字体
            <i class="tips-btn icon-portal-info2 notice-tips" @click="explainDialogClick('openBaseFont')"></i>
          </span>
          <single-input
            class="size-inp"
            style="width: 96px;"
            :value.sync="referenceFontSize"
            inputSuffixs=""
            :min="1"
            :max="200"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item title="系统页面" name="10" v-if="isPhoneFullScreen">
        尾页
        <el-switch :value="isAddSystemEndPage" active-color="#3D82F2" @change="changeAddEndPageStatu"></el-switch>
      </el-collapse-item>
      <el-collapse-item v-if="$store.state.states.showPluginSetting" title="插件" name="11">
        <div>
          <div class="right_font"><span @click="addPlugin" class="icon-portal-plus-small plugin_title"></span></div>
          <div v-for="(item, index) in pluginName" :key="index" class="mt8 plugins">
            <span class="plugin_title mr8">插件名</span>
            <el-input
              class="mr16"
              style="width: 168px"
              :value="item"
              @input="changePluginName(index, $event)"
              placeholder="请输入插件名"
            ></el-input>
            <span @click="delPlugin(index)" class="plugin_title icon-portal-delete"></span>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!--添加视频-->
    <div class="el-message-box music-upload-box" v-show="showUploadMusicPop">
      <div class="el-message-box__header">
        <div class="el-message-box__title"><span>编辑</span></div>
        <button type="button" aria-label="Close" class="el-message-box__headerbtn" @click="closeUploadMusic">
          <i class="el-message-box__close el-icon-close"></i>
        </button>
      </div>
      <div class="el-message-box__content" ref="uploadBox">
        <el-tabs class="mb24" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="本地添加" name="first">
            <div class="mb16">
              <input
                type="file"
                accept="video/*"
                name="uploadFile"
                id="uploadVideo"
                @change="uploadVideoHandle($event)"
              />
              <el-button class="upload-btn"><span class="icon-portal-plus"></span>添加音频</el-button>
            </div>
            <p class="fs14">支持MP3、WMA格式，大小不超过600M</p>
          </el-tab-pane>
          <el-tab-pane label="音频设置" name="second">
            <el-input v-model="musicSrc" placeholder="请输入链接地址"></el-input>
          </el-tab-pane>
        </el-tabs>
        <el-checkbox v-model="isLoopPlay" label="1" @click="this.isLoopPlay = !this.isLoopPlay">循环播放</el-checkbox>
      </div>
      <div class="el-message-box__btns">
        <button type="button" class="el-button el-button--default el-button--small" @click="closeUploadMusic">
          <span> 取消 </span>
        </button>
        <button
          type="button"
          class="el-button el-button--default el-button--small el-button--primary"
          @click="closeUploadMusic"
        >
          <span> 确定 </span>
        </button>
      </div>
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <div class="box" v-if="explainImgSrc || explainVideoSrc">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { primaryStagePageLayoutGenerator as primaryStagePageLayoutGenerator } from "store/modules/stage/state"
import { control_drawer_icon_children } from "materials/icon/menus/index"
import { text_children } from "materials/text/menus/index.js"
import { button_children } from "materials/button/menus/index.js"
import { editor_children } from "materials/editor/menus/index.js" 
import { share_group_children } from "../../../dependencies/shareEmptyLayout/index.js"
import { deepChangeUid, decrypt, isEqual, smartMathMax } from "utils"
import { data_dictionary_map } from "root/static/dataDictionary.js"
import { reverseBuildModel } from "utils/reverseBuildModel.js"

import {
  primaryBigScreenGenerator as primarybigScreenGenerator,
  primaryBigScreenPageLayoutGenerator as primarybigScreenPageLayoutGenerator
} from "../../../store/modules/bigScreen/state"
import {
  primaryAppStageGenerator as primaryappStageGenerator,
  primaryappStageheaderGenerator,
  primaryappStagefooterGenerator,
  primaryappStagePageLayoutGenerator as primaryappStagePageLayoutGenerator
} from "../../../store/modules/appStage/state"

import {
  primaryStageGenerator as primarystageGenerator,
  primaryStageHeaderGenerator as primarystageheaderGenerator,
  primaryStageFooterGenerator as primarystagefooterGenerator,
  primaryStagePageLayoutGenerator as primarystagePageLayoutGenerator
} from "../../../store/modules/stage/state"

const mockData = {
  primarybigScreenGenerator,
  primaryappStageGenerator,
  primarystageGenerator,
  primarystageheaderGenerator,
  primarystagefooterGenerator,
  primaryappStageheaderGenerator,
  primaryappStagefooterGenerator,
  primarybigScreenPageLayoutGenerator,
  primarystagePageLayoutGenerator,
  primaryappStagePageLayoutGenerator
}
export default {
  name: "global-set",
  data() {
    return {
      $this: this,
      activeNames: ["1", "2", "3"],
      showUploadMusicPop: false,
      screenWidth: undefined,
      activeName: "first",
      tabsActive: 0,
      switchWidth: 50,
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainImgSrc: "",
      explainVideoSrc: "",
      recommendColors: [
        "#B8181C",
        "#B12877",
        "#581053",
        "#3A3EB8",
        "#2775C1",
        "#21A0B4",
        "#1A9672",
        "#2E6D36",
        "#D6B43F",
        "#EC8030",
        "rgba(226, 89, 40, 0.6)",
        "rgba(234, 66, 34, 0.4)",
        "#D52428",
        "#000000"
      ],
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      musicType: "本地上传",
      pageWidthList: [
        {
          value: 1200,
          title: "1200px"
        },
        {
          value: 1400,
          title: "1400px"
        },
        {
          value: 1600,
          title: "1600px"
        },
        {
          value: 1920,
          title: "1920px"
        },
        {
          value: "custom",
          title: "自定义"
        }
      ],
      beginCollect: false,
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: "text/css",
        lineNumbers: true,
        line: true
        // more codemirror options, 更多 codemirror 的高级配置...
      },
      tempGlobalStyle: "",
      prevThemeColor: null,
      noticeOptions: [{
        title: '',
        value: true,
        iconClass: 'icon-portal-preview-open1'
      }, {
        title: '',
        value: false,
        iconClass: 'icon-portal-preview-close-one1'
      }],
      noticeTriggerOptions: [{
        label: '首次登录后弹出',
        value: 'login'
      }, {
        label: '更换浏览器后弹出',
        value: 'changeBrowser'
      }]
    }
  },
  computed: {
    isHomePage() {
      const pageList = this.$store.state.states.pageList
      const homePageId = pageList.find(item => item.isHomePage == 1)?.publicId
      const pageId = this.$store.state.states.getDataPageIds.pageId
      return homePageId === pageId ? true : false
    },
    ids() {
      return this.$store.state.states.activeID
    },
    isLayout() {
      return this.$store.state[this.request_prefix].page.pageLayoutType
    },
    globalStyle: {
      get() {
        return this.$store.state[this.request_prefix].page.globalStyle
      },
      set(newVal) {
        this.tempGlobalStyle = newVal
      }
    },
    isPcFixedTypeArea: {
      get() {
        let page = this.$store.state[this.request_prefix].page
        return this.checkAndSetPrimaryVal(page, "isPcFixedTypeArea", "isPcFixedTypeArea", false)
      },
      set(val) {
        this.$changePageAttribute({ option_name: "isPcFixedTypeArea", option_val: val })
      }
    },
    stageSource() {
      return this.$store.state[this.request_prefix].page.children
    },
    isPhoneFullScreen() {
      return this.$store.state[this.request_prefix].page.isPhoneFullScreen
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    // isShowHeader: {
    //   get() {
    //     return this.$store.state[this.request_prefix].page.isShowHeader || false
    //   },
    //   set(newVal) {
    //     historyCombineWrap(() => {
    //       this.$changePageAttribute({ option_name: "isShowHeader", option_val: newVal })
    //       if (this.isLayout) {
    //         // 布局模式
    //         this.layoutChangeShowBaseStatus("header", newVal)
    //       } else {
    //         // 多画布模式
    //         this.changeShowBaseStatus("header", newVal)
    //       }
    //       // 取消头部显示，同时取消引用
    //       if (["listPage", "detailPage", "equalPage"].includes(this.pageType) && !newVal) {
    //         const headerIndex = this.pageLayoutList.findIndex(pageLayout => pageLayout.options.inDocument === "header")
    //         this.$changeOptionsEV([false, false], ["isRefHome", "isRefNav"], false, "", {
    //           containerId: 0,
    //           pageLayoutId: headerIndex
    //         })
    //       }
    //     })()
    //   }
    // },
    pluginName: {
      get() {
        const page = this.$store.state[this.request_prefix].page
        if (!page?.pluginName) {
          this.$set(page, "pluginName", [])
        }
        return page.pluginName
      },
      set(val) {
        this.$changePageAttribute({ option_name: "pluginName", option_val: val })
      }
    },
    // isShowFooter: {
    //   get() {
    //     return this.$store.state[this.request_prefix].page.isShowFooter || false
    //   },
    //   set(newVal) {
    //     this.$changePageAttribute({ option_name: "isShowFooter", option_val: newVal })
    //     if (this.isLayout) {
    //       // 布局模式
    //       this.layoutChangeShowBaseStatus("footer", newVal)
    //     } else {
    //       // 多画布模式
    //       this.changeShowBaseStatus("footer", newVal)
    //     }
    //     // 取消头部显示，同时取消引用
    //     if (["listPage", "detailPage", "equalPage"].includes(this.pageType) && !newVal) {
    //       const footerIndex = this.pageLayoutList.findIndex(pageLayout => pageLayout.options.inDocument === "footer")
    //       this.$changeOptionsEV([false, false], ["isRefHome", "isRefNav"], false, "", {
    //         containerId: 0,
    //         pageLayoutId: footerIndex
    //       })
    //     }
    //   }
    // },
    // isShowAnchor: {
    //   get() {
    //     return this.$store.state[this.request_prefix].page.isShowAnchor || false
    //   },
    //   set(newVal) {
    //     this.$changePageAttribute({ option_name: "isShowAnchor", option_val: newVal })
    //     if (this.isLayout) {
    //       // 布局模式
    //       this.layoutChangeShowBaseStatus("anchor", newVal)
    //     } else {
    //       // 多画布模式
    //       this.changeShowBaseStatus("anchor", newVal)
    //     }
    //   }
    // },
    editPageThemeColor: {
      get() {
        let flag = this.$store.state[this.request_prefix].page.editPageThemeColor
        if (typeof flag === "undefined") {
          flag = "0"
          this.$changePageAttribute({ option_name: "editPageThemeColor", option_val: flag }, true)
        }
        return flag
      },
      set(val) {
        this.$changePageAttribute({ option_name: "editPageThemeColor", option_val: val })
      }
    },
    editPageThemeColorList() {
      return this.$store.state.states.editPageThemeColorList
    },
    enableNotice: {
      get() {
        return this.$store.state[this.request_prefix].page.enableNotice ?? false
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "enableNotice", option_val: newVal })
        this.updateNoticeDrawer(newVal)
      }
    },
    noticeDrawerSourceId() {
      const noticeDrawer = this.$store.state[this.request_prefix].page.pageLayoutList.find(item => item.options.inDocument === "drawer" && item.options.source_id == 'notice_drawer')
      return noticeDrawer?.options?.source_id
    },
    showNoticeLayout: {
      get() {
        return this.$store.state[this.request_prefix].page.showNoticeLayout ?? false
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "showNoticeLayout", option_val: newVal })
        // 打开页面提示弹窗
        this.$eventBus.$emit('control-drawer', {
          openDrawer: newVal,
          sourceId: this.noticeDrawerSourceId
        })
      }
    },
    noticeTriggerType: {
      get() {
        return this.$store.state[this.request_prefix].page.noticeTriggerType ?? 'login'
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "noticeTriggerType", option_val: newVal })
      }
    },
    pageWidth: {
      get() {
        let flag = this.$store.state[this.request_prefix].page.pageWidth
        if (typeof flag === "undefined") {
          flag = 1920
          this.$changePageAttribute({ option_name: "pageWidth", option_val: flag }, true)
        }
        return flag
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "pageWidth", option_val: newVal })
      }
    },
    customWidth: {
      get() {
        return this.$store.state[this.request_prefix].page.customWidth
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "customWidth", option_val: newVal })
      }
    },
    openComplexFont: {
      get() {
        let flag = this.$store.state[this.request_prefix].page.openComplexFont
        if (typeof flag === "undefined") {
          flag = false
          this.$changePageAttribute({ option_name: "openComplexFont", option_val: flag }, true)
        }
        return flag
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "openComplexFont", option_val: newVal })
      }
    },
    themeColor: {
      get() {
        let flag = this.$store.state[this.request_prefix].page.themeColor
        if (typeof flag === "undefined") {
          flag = "#3D82F2"
          this.$changePageAttribute({ option_name: "themeColor", option_val: flag }, true)
        }
        if (!this.prevThemeColor) {
          this.prevThemeColor = flag
        }
        return flag
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "themeColor", option_val: newVal }, true)
      }
    },
    themeColorList: {
      get() {
        let themeColorList = this.$store.state[this.request_prefix].page.themeColorList || []
        if (themeColorList.length === 0) {
          const themeColor = {
            id: 0,
            color: this.themeColor,
            name: "主题色1",
            tags: ""
          }
          themeColorList.push(themeColor)
        }
        return themeColorList
      }
    },
    imgSrc: {
      get() {
        return this.$store.state[this.request_prefix].page.globalBgSetting
          ? this.$store.state[this.request_prefix].page.globalBgSetting.imgSrc
          : ""
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.imgSrc", option_val: newVal })
      }
    },
    clipSize: {
      get() {
        return this.$store.state[this.request_prefix].page.globalBgSetting
          ? this.$store.state[this.request_prefix].page.globalBgSetting.clipSize
          : "auto auto"
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.clipSize", option_val: newVal })
      }
    },
    repeatType: {
      get() {
        return this.$store.state[this.request_prefix].page.globalBgSetting
          ? this.$store.state[this.request_prefix].page.globalBgSetting.repeatType
          : "no-repeat"
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.repeatType", option_val: newVal })
      }
    },
    alignType: {
      get() {
        return this.$store.state[this.request_prefix].page.globalBgSetting
          ? this.$store.state[this.request_prefix].page.globalBgSetting.alignType
          : "left top"
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.alignType", option_val: newVal })
      }
    },
    opacity: {
      get() {
        let globalBgSetting = this.$store.state[this.request_prefix].page.globalBgSetting
        return globalBgSetting && globalBgSetting.hasOwnProperty("opacity") ? globalBgSetting.opacity : 100
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.opacity", option_val: newVal })
      }
    },
    color: {
      get() {
        return this.$store.state[this.request_prefix].page.globalBgSetting
          ? this.$store.state[this.request_prefix].page.globalBgSetting.color
          : "#fff"
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.color", option_val: newVal })
      }
    },
    colorlinearGradientAngle: {
      get() {
        return this.$store.state[this.request_prefix].page.globalBgSetting
          ? this.$store.state[this.request_prefix].page.globalBgSetting.colorlinearGradientAngle
          : 90
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.colorlinearGradientAngle", option_val: newVal })
      }
    },
    colorType: {
      get() {
        return this.$store.state[this.request_prefix].page.globalBgSetting
          ? this.$store.state[this.request_prefix].page.globalBgSetting.colorType
          : "纯色"
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.colorType", option_val: newVal })
      }
    },
    startColor: {
      get() {
        return this.$store.state[this.request_prefix].page.globalBgSetting
          ? this.$store.state[this.request_prefix].page.globalBgSetting.startColor
          : "#fff"
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.startColor", option_val: newVal })
      }
    },
    endColor: {
      get() {
        return this.$store.state[this.request_prefix].page.globalBgSetting
          ? this.$store.state[this.request_prefix].page.globalBgSetting.endColor
          : "#fff"
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.endColor", option_val: newVal })
      }
    },
    bgType: {
      get() {
        return this.$store.state[this.request_prefix].page.globalBgSetting
          ? this.$store.state[this.request_prefix].page.globalBgSetting.bgType
          : "color"
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.bgType", option_val: newVal })
      }
    },
    background: {
      get() {
        let background = this.checkAndSetPrimaryVal(
          this.$store.state[this.request_prefix].page.globalBgSetting,
          "background",
          "background",
          []
        )
        if (background && Array.isArray(background) && background.length > 0) {
          return this.$store.state[this.request_prefix].page.globalBgSetting.background
        }
        let newBackground = []
        newBackground.push({
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: this.colorType === "纯色" ? this.color : "rgba(0,0,0,0)"
        })
        if (this.colorType === "线性渐变") {
          newBackground.push({
            type: "linearGradient",
            label: "线性渐变",
            data: {
              angle: this.colorlinearGradientAngle,
              stops: [
                [this.startColor, 0],
                [this.endColor, 1]
              ]
            }
          })
        }
        if (this.imgUrl) {
          newBackground.push({
            type: "img",
            label: "图片",
            imgUrl: this.imgSrc,
            clipSize: this.clipSize,
            repeatType: this.repeatType,
            alignType: this.alignType,
            opacity: 100
          })
        }
        this.$changePageAttribute({ option_name: "globalBgSetting.background", option_val: newBackground }, true)
        return newBackground
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "globalBgSetting.background", option_val: newVal })
      }
    },
    isBackgroundFixed: {
      get() {
        return this.$store.state[this.request_prefix].page.isBackgroundFixed || false
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "isBackgroundFixed", option_val: newVal })
      }
    },
    musicSrc: {
      get() {
        return this.$store.state[this.request_prefix].page.bgMusicSrc
          ? this.$store.state[this.request_prefix].page.bgMusicSrc
          : ""
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "bgMusicSrc", option_val: newVal })
      }
    },
    musicName: {
      get() {
        return this.$store.state[this.request_prefix].page.bgMusicName
          ? this.$store.state[this.request_prefix].page.bgMusicName
          : ""
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "bgMusicName", option_val: newVal })
      }
    },
    isAddSystemEndPage: {
      get() {
        return this.$store.state[this.request_prefix].page.isAddSystemEndPage
          ? this.$store.state[this.request_prefix].page.isAddSystemEndPage
          : false
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "isAddSystemEndPage", option_val: newVal })
        if (newVal) {
          this.addContainer()
        } else {
          this.delMyContainer()
        }
      }
    },
    isLoopPlay: {
      get() {
        return this.$store.state[this.request_prefix].page.bgMusicLoop
          ? this.$store.state[this.request_prefix].page.bgMusicLoop
          : ""
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "bgMusicLoop", option_val: newVal })
      }
    },
    misicPosition: {
      get() {
        return this.$store.state[this.request_prefix].page.misicPosition
          ? this.$store.state[this.request_prefix].page.misicPosition
          : "left"
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "misicPosition", option_val: newVal })
      }
    },
    pageLayoutList: {
      get() {
        return this.$store.state[this.request_prefix].page.pageLayoutList
      },
      set(val) {
        this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: val })
      }
    },
    isCustomWxShare: {
      get() {
        let plugName = this.$store.state[this.request_prefix].page.pluginName
        if (plugName && plugName.findIndex(item => item.indexOf("fetch-wxShare") > -1) > -1) {
          return true
        }
        return false
      },
      set(val) {
        this.handleWxShare(val)
      }
    },
    shareTitle: {
      get() {
        if (!this.$store.state[this.request_prefix].page.hasOwnProperty("wxShare")) {
          this.$changePageAttribute({ option_name: "wxShare", option_val: { shareTitle: "" } }, true)
        }
        return this.$store.state[this.request_prefix].page.wxShare.shareTitle
      },
      set(val) {
        this.$changePageAttribute({ option_name: "wxShare.shareTitle", option_val: val })
      }
    },
    shareLogo: {
      get() {
        if (!this.$store.state[this.request_prefix].page.hasOwnProperty("wxShare")) {
          this.$changePageAttribute({ option_name: "wxShare", option_val: {} }, true)
          return ""
        }
        return this.$store.state[this.request_prefix].page.wxShare.shareLogo || ""
      },
      set(val) {
        this.$changePageAttribute({ option_name: "wxShare.shareLogo", option_val: val })
      }
    },
    shareUrl: {
      get() {
        if (!this.$store.state[this.request_prefix].page.hasOwnProperty("wxShare")) {
          this.$changePageAttribute({ option_name: "wxShare", option_val: {} }, true)
          return ""
        }
        return this.$store.state[this.request_prefix].page.wxShare.shareUrl || ""
      },
      set(val) {
        this.$changePageAttribute({ option_name: "wxShare.shareUrl", option_val: val })
      }
    },
    shareType: {
      get() {
        if (!this.$store.state[this.request_prefix].page.hasOwnProperty("wxShare")) {
          this.$changePageAttribute({ option_name: "wxShare", option_val: { shareType: "1" } }, true)
        }
        return this.$store.state[this.request_prefix].page.wxShare.shareType || "1"
      },
      set(val) {
        this.$changePageAttribute({ option_name: "wxShare.shareType", option_val: val }, true)
      }
    },
    enableFullScroll: {
      get() {
        return this.$store.state[this.request_prefix].page.enableFullScroll
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "enableFullScroll", option_val: newVal })
      }
    },
    overflowControl: {
      get() {
        return this.$store.state[this.request_prefix].page.overflowControl || "scroll"
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "overflowControl", option_val: newVal })
      }
    },
    showScrollModelSetting() {
      return this.enableFullScroll
    },
    scrollModel: {
      get() {
        return this.$store.state[this.request_prefix].page.scrollModel || "smooth"
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "scrollModel", option_val: newVal })
      }
    },
    enablePullRefresh: {
      get() {
        return this.$store.state[this.request_prefix].page.enablePullRefresh
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "enablePullRefresh", option_val: newVal })
      }
    },
    pullText: {
      get() {
        return this.$store.state[this.request_prefix].page.pullText
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "pullText", option_val: newVal })
      }
    },
    releaseText: {
      get() {
        return this.$store.state[this.request_prefix].page.releaseText
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "releaseText", option_val: newVal })
      }
    },
    isAdmin() {
      return this.$store.state.states.managerType === 1 ? true : false
    },
    isSubHeadPage() {
      return this.$store.state[this.request_prefix].page.isSubHeadPage
    },
    referenceFontSize: {
      get() {
        return this.$store.state[this.request_prefix].page.referenceFontSize || (this.request_prefix == "stage" ? 192 : 41.4)
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "referenceFontSize", option_val: newVal })
      }
    }
  },
  mounted() {
    this.screenWidth = window.screen.width
    // 处理有些页面上已经有了锚点 但是还是未勾选的情况
    let anchorElement = document.getElementsByClassName("anchor-layout")
    if (anchorElement && anchorElement.length === 1) {
      this.isShowAnchor = true
    }
  },
  methods: {
    handleChange(val) {
      if (val?.includes('8')) {
        setTimeout(() => {
          this.$refs.editor && this.$refs.editor.refresh()
        }, 0)
      }
    },
    updateNoticeDrawer(newVal) {
      if (newVal) {
        const noticeDrawer = this.pageLayoutList.find(item => item.options.inDocument === "drawer" && item.options.source_id == 'notice_drawer')
        if (!noticeDrawer) {
          this.createNoticeDrawer()
        } else {
          this.$changeOptionsEV(true, "isShow", false, null, {
            container_id: this.ids.container_id,
            pageLayoutId: noticeDrawer.id
          }, true)
        }
      } else {
        // 禁用页面提示
        const noticeDrawer = this.pageLayoutList.find(item => item.options.inDocument === "drawer" && item.options.source_id == 'notice_drawer')
        noticeDrawer && this.$changeOptionsEV(false, "isShow", false, null, {
          container_id: this.ids.container_id,
          pageLayoutId: noticeDrawer.id
        }, true)
        this.$changePageAttribute({ option_name: "showNoticeLayout", option_val: false })
      }
    },
    createNoticeDrawer() {
      const stage = this.request_prefix
      const noticeWidth = stage === "stage" ? 500 : 360
      const noticeHeight = stage === "stage" ? 500 : 500
      const richTextWidth = stage === "stage" ? 460 : 312
      const richTextHeight = stage === "stage" ? 360 : 346
      const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
        container_id: 0
      }).children
      let _rect_id = -1
      if (allRects.length > 0) {
        _rect_id = smartMathMax(
          ...allRects.map(function (o) {
            return o.rect_id
          })
        )
      }
      let rect_id = _rect_id + 1
      console.log("control_drawer_button_children", control_drawer_icon_children[0].attribute)
      const rectAttr = JSON.parse(JSON.stringify(control_drawer_icon_children[0].attribute))
      rectAttr.options.drawerSourceId = "notice_drawer"
      rectAttr.options.zIndex = 100000
      rectAttr.options.noticeInnerComp = true
      const params = {
        containerID: 0,
        data: rectAttr
      }
      this.$store.dispatch(this.request_prefix + "/addElement", params)
      const noticeTitleRectAttr = JSON.parse(JSON.stringify(text_children[0].attribute))
      noticeTitleRectAttr.options = {
        ...noticeTitleRectAttr.options,
        content: "用户须知",
        fontSize: 18,
        lineHeight: 18,
        fontWeight: 600,
        height: 18,
        color: "rgba(0, 0, 0, 0.8)",
        leftType: "%",
        left: 50,
        topType: "%",
        top: 0,
        width: 168,
        textAlign: "center",
        margin: [0, 0, 0, "-50%"],
        offset: [30, 0, 0, 0],
        isQuickSite: true,
      }
      this.$store.dispatch(this.request_prefix + "/addElement", {
        containerID: 0,
        data: noticeTitleRectAttr
      })
      const noticeConfirmBtnRectAttr = JSON.parse(JSON.stringify(button_children[0].attribute))
      noticeConfirmBtnRectAttr.options = {
        ...noticeConfirmBtnRectAttr.options,
        content: "确认",
        leftType: "%",
        left: 50,
        topType: "%",
        top: 100,
        offset: [0, 0, 20, 0],
        isQuickSite: true,
        margin: ["-100%", 0, 0, "-50%"],
        drawerSourceId: "notice_drawer",
        pluginName: ['noticeConfirmPlugin'],
        height: 32,
        fontSize: 14,
        cursorType: "pointer",
        noticeInnerComp: true
      }
      this.$store.dispatch(this.request_prefix + "/addElement", {
        containerID: 0,
        data: noticeConfirmBtnRectAttr
      })

      const noticeContentRectAttr = JSON.parse(JSON.stringify(editor_children[0].attribute))
      noticeContentRectAttr.options = {
        ...noticeContentRectAttr.options,
        content: "<p style=\"font-size: 16px; font-weight: 600; line-height: 1.4;\"><span style=\"white-space: normal; color: #000000;\">1.<span style=\"white-space: pre;\"> </span>账号安全</span></p>\n<span style=\"font-size: 14px;\">请妥善保管您的账号信息，不要将密码泄露给他人。如发现账号异常，请及时修改密码或联系客服。</span>\n<p style=\"font-size: 16px; font-weight: 600; line-height: 1.4;\"><span style=\"white-space: normal; color: #000000;\">2.<span style=\"white-space: pre;\"> </span>使用规范</span></p>\n<span style=\"font-size: 14px;\">遵守平台的相关规则，不发布违法、违规或不符合社区规范的内容。违规行为可能导致账号限制或封禁。</span><br />\n<p style=\"font-size: 16px; font-weight: 600; line-height: 1.4;\"><span style=\"white-space: normal; color: #000000;\">3.<span style=\"white-space: pre;\"> </span>隐私保护</span></p>\n<span style=\"font-size: 14px;\">平台承诺保护您的个人信息，未经授权不会向第三方泄露，但根据法律要求或平台安全需求可能例外。</span>\n<p style=\"font-size: 16px; font-weight: 600; line-height: 1.4;\"><span style=\"white-space: normal; color: #000000;\">4.<span style=\"white-space: pre;\"> </span>服务条款</span></p>\n<span style=\"font-size: 14px;\">使用本平台服务即视为同意相关服务条款，具体内容请参考[服务条款]。</span>\n<p style=\"font-size: 16px; font-weight: 600; line-height: 1.4;\"><span style=\"white-space: normal; color: #000000;\">5.<span style=\"white-space: pre;\"> </span>免责声明</span></p>\n<span style=\"font-size: 14px;\">平台对用户发布内容不承担责任，但保留对违规内容进行处理的权利。因使用本平台服务引发的损失，由用户自行承担。如有疑问，请联系在线客服或发送邮件至 support@example.com</span>。",
        leftType: "%",
        left: 50,
        topType: "%",
        top: 50,
        width: richTextWidth,
        height: richTextHeight,
        isQuickSite: true,
        margin: ["-50%", 0, 0, "-50%"],
        offset: [0, 0, 0, 0],
        textOverFlowType: "auto"
      }
      this.$store.dispatch(this.request_prefix + "/addElement", {
        containerID: 0,
        data: noticeContentRectAttr
      })
      let drawerParams = [new primaryStagePageLayoutGenerator(1)][0]
      const id =
      Math.max.apply(
        0,
        this.pageLayoutList.map(pageLayout => pageLayout.id)
      ) + 1
      drawerParams.id = id
      drawerParams.options.isShow = true
      drawerParams.options.padding = [0, 0, 0, 0]
      drawerParams.layout.rows[0].options.height = 500 // 顶部高度50+边框6
      drawerParams.options.source_id = "notice_drawer"
      drawerParams.options.inDocument = "drawer"
      drawerParams.options.bg = [
        {
        color: "rgba(255, 255, 255, 1)",
        isThemeColor: false,
        label: "颜色",
        type: "color"
        }
      ]
      // 抽屉默认属性
      drawerParams.options.drawerParams = {
        showConfirm: true,
        // 显示关闭按钮
        showClose: true,
        // 点击遮罩是否关闭抽屉
        maskClosable: false,
        direction: "center", // 抽屉方向 ltr:从左到右 rtl:从右到左 ttb:从上到下 btt:从下到上
        width: noticeWidth,
        height: noticeHeight,
        title: "我是标题",
        opacity: 100,
        borderTypeFlag: 1,
        borderRadius: [8, 8, 8, 8],
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: "rgb(61, 130, 242)",
        borderIsThemeColor: false,
        modalTextIsThemeColor: false,
        modalColorArr: {
          data: {
            stops: [["rgba(0, 0, 0, 0.5)", 1]],
            angle: 0
          },
          type: "color",
          label: "颜色",
          isThemeColor: false,
        },
        modalActiveNameColor: "first"
      }
      const index = this.pageLayoutList.length - 1
      drawerParams.layout.rows[0].rectIds.push(rect_id, rect_id + 1, rect_id + 2, rect_id + 3) // 添加该按钮
      this.$store.dispatch(this.request_prefix + "/insertPageLayout", {
        pagelayout_data: drawerParams,
        index: index
      })
    },
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case "changeFullScroll":
          this.explainTitle = "开启整屏切换"
          this.explainTips =
            "开启后，编辑页所有通栏将自动撑满全屏，网页将以通栏为单位，每次滑动鼠标，切换一整个通栏，实现整体网页的整屏切换效果"
          this.explainVideoSrc = ""
          this.explainImgSrc = ""
          break
        case "openBgFixed":
          this.explainTitle = "固定页面背景"
          this.explainTips =
            "开启后，页面下滑时背景不再跟随滚动，可通过对任意模块设置透明背景，实现如视频所示的动画效果。\n" +
            "此效果设置后请在预览页查看。"
          this.explainVideoSrc = ""
          this.explainImgSrc = ""
          break
        case "notice":
          this.explainTitle = "开启用户须知"
          this.explainTips = "开启后，用户在访问当前门户首页时会弹出一份用户须知弹窗。该弹窗仅在用户初次访问时弹出一次，之后一段时间内将不再出现；若更换新的浏览器，该弹窗会再次弹出。"
          break
        case "openBaseFont":
          this.explainTitle = "基准字体"
          this.explainTips =
            "保存网站，像素单位会转换为rem，默认PC端以192px为基准，移动端以41.4px为基准。"
          this.explainVideoSrc = ""
          this.explainImgSrc = ""
          break
        default:
      }
    },
    changePluginName(index, name) {
      this.$changePageAttribute({ option_name: "pluginName." + index, option_val: name })
    },
    delPlugin(index) {
      const pluginName = [...this.pluginName]
      pluginName.splice(index, 1)
      this.$changePageAttribute({ option_name: "pluginName", option_val: pluginName })
    },
    addPlugin() {
      this.$changePageAttribute({ option_name: "pluginName." + this.pluginName.length, option_val: "" })
    },
    changeStyleColor(id) {
      this.editPageThemeColor = id
    },
    changeAddEndPageStatu(val) {
      if (val) {
        this.isAddSystemEndPage = val
      } else {
        this.$confirm("关闭后将不保存，确认关闭吗？", "", {
          confirmButtonText: "关闭",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: "<p>关闭后将不保存，确认关闭吗？</p>",
          iconClass: "bigScreen_confirm_icon el-icon-warning",
          cancelButtonClass: "bigScreen_confirm_cancel_button",
          confirmButtonClass: "bigScreen_confirm_button",
          customClass: "bigScreen_confirm custom_warning_dialog"
        })
          .then(() => {
            //执行删除操作
            //获取所有键
            this.isAddSystemEndPage = val
            this.handdleClearActive()
            this.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              type: "success",
              message: "关闭成功!"
            })
          })
          .catch(() => {
            this.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              type: "info",
              message: "已取消关闭"
            })
          })
      }
    },
    handdleClearActive() {
      this.$store.commit("states/changeActiveID", null)
      this.$store.commit("states/changeElementType", null)
      this.$store.commit("states/changeToolBarStatus", false)
      this.$store.commit("states/changeAlignHelperStatus", false)
    },
    delMyContainer() {
      // 删除画布
      let thisId = this.stageSource[this.stageSource.length - 1].container_id
      let isEndPage = this.stageSource[this.stageSource.length - 1].options.isEndPage
      if (isEndPage) {
        this.$store.dispatch(this.request_prefix + "/deleteContainer", thisId)
      }
    },
    setPageWidthType(value){
        if(value !== 'custom'){
          this.pageWidth = this.pageWidthList.find(item=>item.value == value)?.value
        }
        this.customWidth = value
    },
    // 多画布模式显示/添加头，底
    // changeShowBaseStatus(type, statu) {
    //   let hasBaseStage = false
    //   let _index, thisId
    //   switch (type) {
    //     case "header":
    //       _index = 0
    //       thisId = -1
    //       break
    //     case "footer":
    //       _index = this.stageSource.length - 1
    //       thisId = this.stageSource[this.stageSource.length - 1].container_id
    //       break
    //     default:
    //   }
    //   if (this.stageSource[_index].options?.inDocument && this.stageSource[_index].options.inDocument === type) {
    //     this.$changeOptionsEV(statu, "isShow", false, "", {
    //       containerId: this.stageSource[_index].container_id
    //     })
    //     hasBaseStage = true
    //   }
    //   // 去掉脏数据，针对某些页面有两个头或者底的情况 提前删除
    //   for (let i = 0; i < this.stageSource.length; i++) {
    //     if (
    //       i !== _index &&
    //       this.stageSource[i].options?.inDocument &&
    //       this.stageSource[i].options.inDocument === type
    //     ) {
    //       this.$store.dispatch(this.request_prefix + "/deleteContainer", this.stageSource[i].container_id)
    //     }
    //   }
    //   if (!hasBaseStage) {
    //     // 新加头底为上传上传样式的第一个
    //     this.getFirstStyle(type, statu, _index)
    //   }
    // },
    // 布局模式显示/添加头，底
    // layoutChangeShowBaseStatus(type, statu) {
    //   let pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
    //   let hasBaseStage = false
    //   const _index = pageLayoutList.findIndex(layout => layout.options.inDocument === type)
    //   if (_index > -1) {
    //     this.$changeOptionsEV(statu, "isShow", false, "", {
    //       containerId: 0,
    //       pageLayoutId: _index
    //     })
    //     hasBaseStage = true
    //     if (type === "anchor" && statu) {
    //       this.initAnchor(pageLayoutList[_index])
    //     }
    //   }
    //   // 去掉脏数据，针对某些页面有两个头或者底的情况 提前删除
    //   for (let i = 0; i < pageLayoutList.length; i++) {
    //     if (i !== _index && pageLayoutList[i].options?.inDocument && pageLayoutList[i].options.inDocument === type) {
    //       this.delElementHandle(pageLayoutList[i])
    //       this.pageLayoutList.splice(i, 1)
    //       this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: pageLayoutList })
    //     }
    //   }

    //   if (!hasBaseStage) {
    //     // 新加头底为上传上传样式的第一个
    //     this.getFirstStyle(type, statu, _index)
    //   }
    // },
    delElementHandle(cellVal) {
      let rectIds = cellVal.rectIds ? JSON.parse(JSON.stringify(cellVal.rectIds)) : []
      rectIds.forEach(item => {
        let param = {
          container_id: this.ids.container_id,
          rect_id: item,
          record: false
        }
        this.$store.dispatch(this.request_prefix + "/deleteElement", param)
      })
      cellVal.layout.rows?.forEach(item => {
        if (item.rectIds && item.rectIds.length > 0) {
          this.delElementHandle(item)
        }
      })
      cellVal.layout.cols?.forEach(item => {
        if (item.rectIds && item.rectIds.length > 0) {
          this.delElementHandle(item)
        }
      })
    },
    // 新加入rect
    async addNewRect(param, e, type) {
      let rectAttr = JSON.parse(JSON.stringify(param.rectAttr))
      // 如果当前数据中存在appId判断当前组件是否是系统保存好的样式
      if (rectAttr.options.myFetchParam?.appId || rectAttr.options.appId) {
        //更新appid
        const appId = rectAttr.options.appId ? rectAttr.options.appId : rectAttr.options.myFetchParam?.appId
        // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
        const isSearchComponent = rectAttr.options.pluginName?.includes("searchComponentPlugin")
        const isNavComponent = rectAttr.shape.toLowerCase().includes("nav")
        const res = await this.$styleToSaveModule(
          "31CB73E03E24BBFF",
          "临时",
          appId,
          param.isClone,
          isSearchComponent,
          isNavComponent
        )
        if (!!res.appId) {
          // 没有myfetchparam的组件 比如搜索组件 更新appId
          rectAttr.options.appId = res.appId
          const params = {
            containerID: this.ids.container_id,
            data: rectAttr
          }
          this.$store.dispatch(this.request_prefix + "/addElement", params).then(res => {})

          let newIndex = param.index
          const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
            container_id: this.ids.container_id
          }).children
          let _rect_id = -1
          if (allRects.length > 0) {
            _rect_id = smartMathMax(
              ...allRects.map(function (o) {
                return o.rect_id
              })
            )
          }
          let rect_id = _rect_id
          if (typeof newIndex !== "undefined") {
            param.cellRect.splice(newIndex, 1, rect_id)
          } else {
            param.cellRect.push(rect_id)
          }
        }
      } else {
        const params = {
          containerID: this.ids.container_id,
          data: rectAttr
        }
        this.$store.dispatch(this.request_prefix + "/addElement", params)
        let newIndex = param.index
        const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          container_id: this.ids.container_id
        }).children
        let _rect_id = -1
        if (allRects.length > 0) {
          _rect_id = smartMathMax(
            ...allRects.map(function (o) {
              return o.rect_id
            })
          )
        }
        let rect_id = _rect_id
        if (type === "addBtn" && typeof newIndex !== "undefined") {
          // 添加锚点按钮逻辑
          param.cellRect.splice(newIndex, 0, rect_id)
        } else {
          if (typeof newIndex !== "undefined") {
            param.cellRect.splice(newIndex, 1, rect_id)
          } else {
            param.cellRect.push(rect_id)
          }
        }
      }
    },
    getNewLayoutId() {
      let id = 1
      this.pageLayoutList.forEach(item => {
        id = item.id && item.id >= id ? item.id + 1 : id
      })
      return id
    },
    addContainer() {
      let thisId = this.stageSource[this.stageSource.length - 1].container_id
      let isEndPage = this.stageSource[this.stageSource.length - 1].options.isEndPage
      if (isEndPage) {
        return
      }
      const param = {
        container_data: new mockData["primary" + this.request_prefix + "Generator"](),
        id: thisId
      }
      param.container_data.options.isEndPage = true
      param.container_data.options.containerAnimateSet = {
        direction: "upDown",
        animateType: "regular",
        animateClass__pageUp: "up",
        animateClass__pageDown: "down",
        nextAnimateClass: "",
        prevAnimateClass: "",
        isAutoPlay: false,
        autoPlayDelay: 3
      }
      let data = JSON.parse(JSON.stringify(share_group_children[0].attribute))
      data.rect_id = 0
      deepChangeUid(data)
      param.container_data.children.push(data)
      this.$store.dispatch(this.request_prefix + "/insertContainer", JSON.parse(JSON.stringify(param)))
    },
    recoverDefaultWidth() {
      this.pageWidth = this.request_prefix == "stage" ? 1920 : 375
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    openUploadMusic() {
      this.showUploadMusicPop = true
    },
    closeUploadMusic() {
      this.showUploadMusicPop = false
    },
    // 切换当前tab激活项
    changeActiveHandle(event, flag) {
      event.stopPropagation()
      this.tabsActive = flag
    },
    // 上传视频
    uploadVideoHandle: function () {
      // todo 带产品完善需求再开发
      var _this = this
      var size = 600 //600M
      var isOverSize = verificationPicFile($("#uploadVideo")[0], size)
      if (!isOverSize) {
        console("视频大小不能超过600M")
        return
      }
      var file = $("#uploadVideo").get(0).files[0]
      var reader = new FileReader()
      var name = file.name

      // $.ajaxFileUpload({
      //       url: '/upload', //用于文件上传的服务器端请求地址
      //       secureuri: false, //是否需要安全协议，一般设置为false
      //       fileElementId: 'uploadVideo', //文件上传域的ID
      //       dataType: 'json', //返回值类型 一般设置为json
      //       success: function (res, status) {
      //         if (res.code == 1) {
      //           $("#uploadVideoName").val(name);
      //           $("#uploadVideo").val(null);
      //           _this.showData.videoUrl= res.data.url;
      //           $("#uploadVideo").parents(".upload-bg-btn").hide();
      //           $(".uploaded-file").show();
      //         }
      //       },
      //       error: function (data, status, e) {
      //         alert(e);
      //       }
      //     }
      // )
    },
    handleMusicPreview(file) {
      console.log(file)
    },
    handleMusicSuccess(response, file, fileList) {
      console.log(response)
      let size = Number(file.size / 1024 / 1024)
      if (size > 600) return
      this.musicSrc = response.data.url
      this.musicName = response.data.name
    },
    handleMusicfail(err, file, fileList) {
      console.log(err)
    },
    handleMusicDel() {
      this.musicSrc = ""
      this.musicName = ""
    },
    activeChangeColor(val) {
      this.themeColor = val
    },
    onChangeColor(val) {
      if (!isEqual(this.prevThemeColor, val)) {
        this.$addHistory({
          type: "update",
          stateType: "updatePageProperty",
          payload: {
            ...this.myId,
            option_name: "themeColor",
            option_val: ""
          },
          before: this.prevThemeColor,
          data: val,
          ignoreRecord: true
        })
      }
      this.prevThemeColor = val
    },
    activeChangeColorList(val, index) {
      this.themeColorList[index].color = val
      if (this.themeColorList.length === 1) {
        this.themeColor = val
      }
      this.$changePageAttribute({ option_name: "themeColorList", option_val: this.themeColorList })
    },
    // 获取通栏的指定分类下的第一个数据
    async getFirstPageLayoutEncId(encTypeId) {
      let data
      await this.$API
        .queryFirstComponentContent({
          encId: encTypeId
        })
        .then(res => {
          if (res.data.code === 1) {
            data = res.data.data.moduleContent
            if (data !== undefined && data.content && data.content.length > 30) {
              //还原被encryption方法加密过json字符串
              data.content = decrypt(data.content, data_dictionary_map)
              //将json中的rem转为px
              reverseBuildModel(data.content)
            }
          }
        })
      return data
    },
    // 处理微信相关的东西
    handleWxShare(flag) {
      // true为开启自定义分享  false为关闭自定义分享
      let plugName = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page)).pluginName
      switch (flag) {
        case true:
          if (!plugName) {
            plugName = ["fetch-wxShare"]
          } else {
            plugName.push("fetch-wxShare")
          }
          break
        case false:
          if (plugName) {
            let _index = plugName.findIndex(item => item.indexOf("fetch-wxShare") > -1)
            plugName.splice(_index, 1)
          }
          break
        default:
      }
      this.$changePageAttribute({ option_name: "pluginName", option_val: plugName })
    },
    updateGlobalStyle() {
      this.$changePageAttribute({ option_name: "globalStyle", option_val: this.tempGlobalStyle })
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-tips {
  vertical-align: -1px;
}
.block-setting {
  padding: 12px;
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background: rgba(251, 252, 253, 1);
}
.basic-item:not(:last-child) {
  margin-bottom: 12px;
}
.page-set-container {
  color: rgba(0, 0, 0, 0.8);
  .title {
    position: relative;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.8);
  }
  .recover-btn {
    color: var(--themeColor);
  }
  .tips {
    color: rgba(0, 0, 0, 0.4);
  }
}
.recommend-colors {
  display: flex;
  flex-wrap: wrap;
  > li {
    margin-right: 8px;
    width: 20px;
    height: 20px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    border-radius: 2px;
  }
}
.upload-btn {
  width: 98px;
  line-height: 28px;
  box-sizing: border-box;
  padding: 0;
  text-align: center;
  span {
    margin-right: 4px;
  }
}
.music-upload-box {
  position: fixed;
  width: 336px;
  left: 584px;
  top: 80px;
  z-index: 10;
  background-color: #fff;
}
::v-deep .music-upload-box {
  .el-message-box__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }
  .el-tabs__nav-wrap {
    &::after {
      display: none;
    }
  }
  .el-tabs__nav-scroll {
    padding: 0;
  }
  .el-tabs__item {
    font-size: 14px;
    color: var(--text);
    margin-top: 0;
    line-height: 40px;
    padding: 0 8px;
    &.is-active {
      color: var(--themeColor);
    }
  }
  .el-tabs__header {
    //background-color: #fff;
    width: 100%;
  }
  p {
    margin-bottom: 0;
    color: rgba(0, 0, 0, 0.4);
  }
}
.music-set {
  position: relative;
  .height24 {
    height: 24px;
  }
  .el-radio {
    margin-right: 16px;
  }
  .tips {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.4);
  }
  .music-name {
    margin-bottom: 4px;
    color: rgba(0, 0, 0, 0.8);
    font-size: 14px;
    line-height: 20px;
  }
  .card {
    padding: 8px;
  }
  .music-input {
    position: relative;
  }
  .icon-portal-close-one {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 34px;
    height: 32px;
    line-height: 32px;
    display: inline-block;
    text-align: center;
    color: rgba(0, 0, 0, 0.4);
    cursor: pointer;
  }
}
.handle-icon-box {
  position: relative;
  width: 24px;
  height: 24px;
  display: block;
  &:hover {
    .icon {
      background: rgba(0, 0, 0, 0.06);
    }
    .icon-tips {
      display: block;
    }
  }
  .icon {
    display: inline-block;
    text-align: center;
    width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.4);
    font-size: 14px;
    cursor: pointer;
  }
  .icon-tips {
    position: absolute;
    display: none;
    background: rgba(0, 13, 34, 0.9);
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 14px;
    top: -44px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, 0.8);
    z-index: 2;
    line-height: 20px;
    box-sizing: border-box;
    word-break: keep-all;
    &:after {
      position: absolute;
      content: "";
      bottom: -10px;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-color: rgba(0, 13, 34, 0.9) transparent transparent;
      border-style: solid;
      z-index: 2;
    }
  }
}
::v-deep .music-input input {
  padding-right: 34px;
}
.help-container {
  position: absolute;
  right: 12px;
  bottom: 12px;
  padding-left: 20px;
  .help-icon {
    display: inline-block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 20px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    color: #3d82f2;
    background-color: #fff;
    cursor: pointer;
  }
  &:hover {
    .help-dialog {
      display: block;
    }
  }
  .help-dialog {
    position: absolute;
    display: none;
    bottom: 20px;
    right: 46px;
    width: 184px;
    background: #ffffff;
    border: 1px solid #e9e9e9;
    box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
  }
  .style-color-set {
    padding: 12px 16px;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.6);
  }
  .style-colors {
    margin-top: 12px;
    li {
      display: inline-block;
      &:not(:nth-child(6n)) {
        margin-left: 6px;
      }
      &:hover {
        .style-color {
          box-shadow: 0 0 0 2px #3d82f2;
          border: 1px solid #fff;
        }
      }
    }
    .style-color {
      display: inline-block;
      width: 24px;
      height: 24px;
      border: 1px solid rgba(0, 0, 0, 0.07);
      border-radius: 50%;
      cursor: pointer;
    }
  }
}
::v-deep .el-color-picker {
  width: 100%;
  height: 20px;
}
</style>
